export enum OktaRole {
  OFFSHORE_SUPPORT = 'Role: Offshore Support',
  TELEPERF_USERS = 'EXT: TP Users',
  COACH = 'Role: Health Coach',
  NURSE_PRACTITIONER = 'Role: Nurse Practitioner',
  PHYSICAL_THERAPIST = 'Role: Physical Therapist',
  DELIVERY_OPS = 'Role: Delivery Ops',
  FINANCE = 'Role: Finance',
  REVENUE_CYCLE_MANAGER = 'Role: Revenue Cycle Manager',
  PHI_MONITORING = 'Role: Production Monitoring PHI',
  PHI_PRODUCT_MANAGER = 'Role: Product Manager Phi',
  STEADY_MD_ACCESS = 'Role: SteadyMD-Access',
  STEADY_MD_DEVELOPERS = 'Role: SteadyMD-Developers',
  HEALTH_ECONOMIST = 'Role: Health Economists',
  ELIGIBILITY_SELF_SERVICE = 'APP: CTT-Shell eligibility-self-service-access',
  TECHNICAL_SUPPORT = 'Role: Tech Support',
  MEMBER_SUPPORT = 'Role: Member Support',
  CLIENT_SUCCESS = 'APP: CTT-Shell client-success',
  ONBOARDING_SPECIALIST = 'Role: Onboarding Specialist',
  OPERATIONS_MANAGER = 'Role: Operations Manager',
  SUPPLY_CHAIN_MANAGER = 'Role: Supply Chain Manager',
  PRODUCTION_ASSOCIATE = 'Role: Production Associate',
  DATA_ANALYST = 'Role: Data Analyst',
  BILLING_READ = 'APP: CTT-Shell-App (Billing UI) - Billing UI - Read',
  BILLING_WRITE = 'APP: CTT-Shell-App (Billing UI) - Billing UI - Write',
  ACCOUNTING_WRITE = 'APP: CTT-Shell accounting-write',
  ADJUSTMENT_UPLOAD = 'APP: CTT-Shell adjustment-upload',
  ACCOUNTING_READ = 'APP: CTT-Shell accounting-read',
}
